import memoize from 'lodash/memoize';
import PhoneAPI from './api';

/*
 * Yup validation helpers
 */

export const validateAreaCode = memoize((value = '') => {
  if (value.length >= 2) {
    return PhoneAPI.validatePhoneCode(value)
      .then((isValid) => {
        if (!isValid) throw new Error('invalid area code');
        return true;
      })
      .catch(() => false);
  }
  return true;
});

//Would be called with handleOnZeroLength set to true when we don't want schema.test (10 characters) to be executed if the size of areaCode and currentField(phoneNumber) is 0
export const validateFullPhoneLength = (
  areaCode = '',
  schema,
  currentField,
  handleOnZeroLength = false
) => {
  const telephoneLength: number = areaCode ? areaCode.length : 0;
  const currentFieldLength: number = currentField.value
    ? currentField.value.length
    : 0;

  const totalLength = telephoneLength + currentFieldLength;
  if (handleOnZeroLength && totalLength === 0) return schema;

  return schema.test(
    'len',
    'La longitud total debe ser de entre 8 y 10 caracteres',
    () => totalLength >= 8 && totalLength <= 10
  );
};
